import { DynamicNavItemsProvider, NavItem } from '../withNavLayout';
import { prepareNavItems } from './prepareNavItems';

const getProviderPromises = (navItemProvider: DynamicNavItemsProvider) =>
  navItemProvider.fetchFns.map((fetchNavItems) => fetchNavItems());

const handleProviderPromises = (
  providerPromises: Promise<NavItem[]>[],
  navItemProviderTlPre: DynamicNavItemsProvider['moduleTranslationsPre'],
  resolve: (value: unknown) => void
) => {
  Promise.all(providerPromises).then((providerPromisesRes) => {
    const preparedNavItems = providerPromisesRes.flatMap((dynamicNavItems) =>
      prepareNavItems(dynamicNavItems, navItemProviderTlPre)
    );

    resolve(preparedNavItems);
  });
};

export const prepareDynamicNavItems = async (
  dynamicNavItemsProviders: DynamicNavItemsProvider[]
) => {
  const modulesNavItemsPromises = dynamicNavItemsProviders.map(
    (navItemProvider) =>
      new Promise((resolve) => {
        const providerPromises = getProviderPromises(navItemProvider);

        handleProviderPromises(
          providerPromises,
          navItemProvider.moduleTranslationsPre,
          resolve
        );
      })
  );

  return await Promise.all(modulesNavItemsPromises).then((promisesRes) =>
    (promisesRes as NavItem[][]).flat()
  );
};
